var map = {
	"./icon-ActForex.png": "2e59",
	"./icon-CTrader.png": "091e",
	"./icon-Cloud-SingleCurrencyTrading-white.png": "c469",
	"./icon-Cloud-SingleCurrencyTrading.png": "3668",
	"./icon-CloudTrade.png": "fd1e",
	"./icon-DXTrade.png": "678c",
	"./icon-MT4.png": "7881",
	"./icon-MT5.png": "1cc8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "07a0";